import React from "react";

interface Props {
  label: string;
  checked: boolean;
  onChange: () => void;
}

const CategoryCheckbox: React.FC<Props> = ({ label, checked, onChange }) => {
  return (
    <div className="flex items-center space-x-2 mb-2">
      <input 
        type="checkbox" 
        id={label}
        checked={checked} 
        onChange={onChange} 
        className="w-5 h-5 accent-green-600"
        aria-label={label}
      />
      <label htmlFor={label} className="text-sm">{label}</label>
    </div>
  );
};

export default CategoryCheckbox;
